import { Badge } from '@goodneighbor/ui';
import styles from './organization-summary.module.scss';

type OrganizationSummaryProps = {
  name?: string;
  causeType?: string | null;
  skillType?: string | null;
  shareUrl?: string;
};

export const OrganizationSummary = ({
  causeType,
  skillType
}: OrganizationSummaryProps) => (
  <div className={styles.summary}>
    <div className={styles.badgeList}>
      {causeType && (
        <Badge type="color" size="sm" color="gray" className={styles.badge}>
          {causeType}
        </Badge>
      )}
      {skillType && (
        <Badge type="color" size="sm" color="gray" className={styles.badge}>
          {skillType}
        </Badge>
      )}
    </div>
  </div>
);
